// extracted by mini-css-extract-plugin
export var chatHtmlText = "_on-2";
export var chatLink = "_on-0";
export var chatText = "_on-1";